__turbopack_context__.v({
  "inline": "TextReveal-module__oNqwHq__inline",
  "line": "TextReveal-module__oNqwHq__line",
  "textReveal": "TextReveal-module__oNqwHq__textReveal",
});
